import React from "react";
import { Accordion } from "react-bootstrap";

import { ACCORDION_HEADER_ICON_SIZE } from "../../../constants";

/**
 * Inbox customer-sidebar accordion item with icon header and optional body hooks.
 */
const AccordionSection = ({
  eventKey,
  title,
  icon: Icon,
  iconSize = ACCORDION_HEADER_ICON_SIZE,
  onHeaderClick,
  headerTestId,
  bodyTestId,
  bodyClassName,
  onEntering,
  onExiting,
  children,
}) => {
  return (
    <Accordion.Item
      eventKey={eventKey}
      className="inbox-accordion inbox-accordion-icon rounded-0"
    >
      <Accordion.Header
        data-testid={headerTestId}
        className="inbox-accordion-header rounded-0"
        onClick={() => onHeaderClick(eventKey)}
      >
        <div className="d-flex align-items-center">
          <Icon size={iconSize} className="me-2" />
          <p className="fw-bold mb-0">{title}</p>
        </div>
      </Accordion.Header>
      <Accordion.Body
        className={bodyClassName}
        data-testid={bodyTestId}
        onEntering={onEntering}
        onExiting={onExiting}
      >
        {children}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default AccordionSection;
